import { insertRoll, requiredInt, upper, type JanusCtx, type Row } from '../ability/context.js';
import { removeStoredStatus } from '../ability/statuses/status-effect-removal-helpers.js';
import { statusItemId } from '../statuses/expiry.js';
import { janusDecayQuantityStatus } from '../port/k4-dispatch/status_stack_helpers.js';
import { browserDependencies } from '../port/browser-dependencies.js';
import { nativePortValue } from '../port/native-value.js';
import type { E } from '../port/k4-dispatch/support-b2.js';

/** Quantity decay is resolved once in the turn frame, before its remaining DoT. */
export function decayQuantityStatus(ctx: JanusCtx, target: Row, status: Row, base: 'burning' | 'corroding',
  changed: Array<{ status_id: string; status_stack: number }>): number {
  const env = browserDependencies({
    'StatusEffect::getQuantityInfo': () => ({ base, decay: { die: 4, on: 1, lose: 1 } }),
    'StatusEffect::statusRowStack': () => requiredInt(status.status_stack ?? 1, 'turn-tick:status-stack-not-held'),
    roll_dice: (_dice: unknown, die: number) => ctx.roll.d(die),
    remove_status_effect_status_id_single_connection: () => removeStoredStatus(ctx, target, status),
    janus_add_status_stack: (_target: unknown, _affected: unknown, _id: unknown, delta: number) => {
      const next = requiredInt(status.status_stack ?? 1, 'turn-tick:status-stack-not-held') + delta;
      status.status_stack = next;
      changed.push({ status_id: upper(status.status_id), status_stack: next });
      return next;
    },
    item_field: () => null, // The native logger uses the exact held definition/id below.
    insert_log_message: (_roll: unknown, type: string) => insertRoll(ctx, { roll_type_1: type, roll_item_id: statusItemId(status), by: target }),
  }) as unknown as E;
  return nativePortValue(janusDecayQuantityStatus({ value: target }, { value: [] }, status, '', env));
}
